import { ReactElement, useCallback, useEffect, useState } from 'react';

import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { TimetableSlotSelectionEvent } from '@dreryk/react-calendar';

import { registerAppointmentsTimetableSlotSelectionEventListener } from './AppointmentsTimetableSlotSelection.events';

type AppointmentsTimetableSlotSelectionRenderProps = {
   selectedSlot: TimetableSlotSelectionEvent<AppointmentPractitioner>;
   unselectSlot: VoidFunction;
};

type AppointmentsTimetableSlotSelectionProps = {
   readonly onUnselect: VoidFunction;
   readonly children: (renderProps: AppointmentsTimetableSlotSelectionRenderProps) => ReactElement;
};

export const AppointmentsTimetableSlotSelection = (
   props: AppointmentsTimetableSlotSelectionProps
): JSX.Element | null => {
   const [selectedSlot, setSelectedSlot] = useState<TimetableSlotSelectionEvent<AppointmentPractitioner>>();

   useEffect(() => registerAppointmentsTimetableSlotSelectionEventListener((event) => setSelectedSlot(event.detail)), [
      setSelectedSlot,
   ]);

   const unselectSlot = useCallback(() => {
      setSelectedSlot(undefined);
      props.onUnselect();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.onUnselect]);

   if (!selectedSlot) {
      return null;
   }

   return props.children({
      selectedSlot: selectedSlot,
      unselectSlot: unselectSlot,
   });
};
